import { render, staticRenderFns } from "./invoiceFrom.vue?vue&type=template&id=0d0b2d62&scoped=true"
import script from "./invoiceFrom.vue?vue&type=script&lang=js"
export * from "./invoiceFrom.vue?vue&type=script&lang=js"
import style0 from "./invoiceFrom.vue?vue&type=style&index=0&id=0d0b2d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b2d62",
  null
  
)

export default component.exports